/**
 * Gets the plain or HTML text from a fragment/node.
 *
 * @param fragment The fragment to get the text from.
 */
export function getFragmentString(
  fragment: DocumentFragment | Node | null | undefined,
): string {
  if (!fragment) {
    return '';
  }

  if (fragment instanceof Text) {
    return fragment.textContent ?? '';
  }

  if (fragment instanceof Element) {
    return fragment.outerHTML;
  }

  const div = document.createElement('div');

  div.appendChild(fragment);

  return div.innerHTML;
}
